import React, {Suspense} from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import {ThemeProvider, StyledEngineProvider, createTheme, CssBaseline} from '@mui/material';
import settings from './settings';
import {HeaderFooterProvider} from './context/HeaderFooterProvider';
import Header from './components/common/Header';
import Footer from './components/common/Footer';

// put this into hosts file
// # EPG&VOD mapping start
// 127.0.0.1 vod-dev
// 127.0.0.1 spored-dev
// # EPG&VOD mapping end

const epgUrls = ['localhost', 'sporedt', 'spored', 'spored-dev'];
const vodUrls = ['vod', 'videovsebine', 'vodt', 'videovsebinet', 'vod-dev', 'videovsebine-dev'];
const host = window.location.hostname.split('.', 1)[0];

// const AppRoot = React.lazy(() => import(/* webpackChunkName: "epg" */ './pages/Epg'));
const AppRoot = epgUrls.some((url) => host.toLowerCase().includes(url))
  ? React.lazy(() => import(/* webpackChunkName: "epg" */ './pages/Epg'))
  : vodUrls.some((url) => host.toLowerCase().includes(url))
  ? React.lazy(() => import(/* webpackChunkName: "vod" */ './pages/Vod'))
  : undefined;

function App() {
  //const theme = createTheme(adaptV4Theme({
  const theme = createTheme({
    mixins: {
      a1: {
        min2Px: (min) => min * settings.pxperminute,
      },
    },
    breakpoints: {
      keys: ['xs', 'sm', 'smx', 'md', 'bg', 'lg', 'xl'],
      values: {
        xs: 0,
        sm: 600,
        smx: 768,
        md: 960,
        bg: 1132,
        lg: 1280,
        xl: 1920,
      },
    },
    palette: {
      common: {
        black: '#000',
        white: '#fff',
      },
      a1: {
        tooltipBackground: '#6295ac',
        carouselDot: '#d7d7d7',
        linkHover: '#f83a2c',
        border: '#d7d7d7',
        greyishBrown: '#585858',
        showHover: '#d7d7d7',
        showBackground: '#f9f9f9',
        timelineBackground: '#d7d7d7',
        buttonBorder: '#4a4a4a',
        horizontalRuler: '#c4c4c4',
        channelTimelineBorder: '#979797',
        channelHours: '#767676',
        showDetailsPrimary: '#4a4a4a',
        showDetailsSecondary: '#878787',
        showDetailsStar: '#808080',
      },
      primary: {main: '#da291c'},
      secondary: {main: '#000'}, //#6295ac
      type: 'light',
      text: {
        primary: '#000',
        secondary: '#fff',
        action: '#da291c',
        disabled: 'rgba(0, 0, 0, 0.38)',
        hint: 'rgba(0, 0, 0, 0.45)',
        icon: 'rgba(0, 0, 0, 0.50)',
        small: 'gray',
        mobileMenuItem: '#666',
        footerSectionItem: '#212529',
        brownish: '#968585',
      },
      background: {
        default: '#efefef',
        paper: '#fff',
        a1: '#da291c',
        dark: '#000',
        elevation: {
          0: 'rgba(0, 0, 0, 0.04)',
          1: 'rgba(0, 0, 0, 0.05)',
          2: 'rgba(0, 0, 0, 0.07)',
          3: 'rgba(0, 0, 0, 0.08)',
          4: 'rgba(0, 0, 0, 0.09)',
          6: 'rgba(0, 0, 0, 0.11)',
          8: 'rgba(0, 0, 0, 0.12)',
          12: 'rgba(0, 0, 0, 0.14)',
          16: 'rgba(0, 0, 0, 0.15)',
          24: 'rgba(0, 0, 0, 0.16)',
        },
      },
    },
    components: {
      // MuiPaper: {
      //   styleOverrides: {
      //     root: {
      //       borderRadius: 8,
      //     }
      //   }
      // }
    },
    shape: {
      borderRadius: 4,
    },
    typography: {
      fontFamily: ['A1Sans', 'Arial', 'Helvetica', 'sans-serif'].join(','),
      fontFamilySerif: ['A1Serif', 'serif'].join(','),
      fontFamilyVerdana: ['A1Verdana', 'Verdana'].join(','),
    },
    themeName: 'moj-a1',
  });
  // }));

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <div color='primary.main'>
            <Routes>
              <Route
                path='*'
                element={
                  <Suspense fallback={<div />}>
                    <HeaderFooterProvider>
                      <Header />
                      <AppRoot />
                      <Footer />
                    </HeaderFooterProvider>
                  </Suspense>
                }
              />
            </Routes>
          </div>
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
